export default __webpack_public_path__ + "static/analy_back-fe663a380f4c247d666b44387746f5db.png";